import http from './http-services';
import config from '../config/headers';
import tokenGenerator from '../utils/tokenGenerator';
import { getAPIURL } from '../utils/envGetter';

const apiUrl = getAPIURL();

export async function getAll() {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.get(`${apiUrl}/token/all`, config);
  return data;
}

export async function getByID(id) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.get(`${apiUrl}/token/${id}`, config);
  return data;
}

export async function deleteByID(id) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.delete(`${apiUrl}/token/${id}`, config);
  return data;
}

export async function addNew(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.post(`${apiUrl}/token`, body, config);
  return data;
}

export async function updateToken(body) {
  config.headers = { 'Content-Type': 'application/json', Authorization: tokenGenerator() };
  const { data } = await http.put(`${apiUrl}/token`, body, config);
  return data;
}
